module.exports = __webpack_public_path__ + "media/components/country-flag/static/la-6d0cbdbe962333cb63e37b5a813ba477.svg";